
<div class="modal-dialog confirm-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Change Token</h5>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div class="row">
        <div class="form-group col">
          <label class="required" for="keyField">Token Key</label>
          <input class="form-control" id="keyField" type="text" [(ngModel)]="tokenKey" name="key" maxlength="20" minlength="20" required>
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label class="required" for="secretField">Token Secret</label>
          <input class="form-control" id="secretField" type="text" [(ngModel)]="tokenSecret" name="secret" maxlength="40" minlength="40" required>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="changeToken()">Change</button>
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>